import { createReducer } from 'redux-act';
import { setPayment, setState, setStatus, updatePayment } from './actions';

export const defaultPaymentState: WebOrder.State.Payments = {
  status: 'none',
  items: {}
};

const paymentsReducer = createReducer({}, defaultPaymentState);

paymentsReducer.on(setState, (state, payload) => ({
  ...payload
}));

paymentsReducer.on(setStatus, (state, payload) => ({
  ...state,
  ...payload
}));

paymentsReducer.on(setPayment, (state, payload) => ({
  ...state,
  items: {
    ...state.items,
    [payload.paymentId]: {
      ...payload
    }
  }
}));
paymentsReducer.on(updatePayment, (state, payload) => ({
  ...state,
  items: {
    ...state.items,
    [payload.paymentId]: {
      ...state.items[payload.paymentId],
      ...payload
    }
  }
}));

export { paymentsReducer };
